'use client';

import { RedditCommentEmbedBlock } from '../../interfaces/cms';
import RedditEmbedContainer, { REDDIT_CLASSNAME } from './RedditEmbedWrapper';

type RedditCommentEmbedProps = Omit<
  RedditCommentEmbedBlock,
  'type' | 'code' | 'blockType'
>;

/* eslint-disable i18next/no-literal-string */
const RedditCommentEmbed = ({
  commentUrl,
  discussionUrl,
  author,
  subreddit,
  height,
  theme,
  context,
  depth,
  created,
  showTitle,
  hideEdits,
  hideUsername,
  locale,
}: RedditCommentEmbedProps) => {
  return (
    <RedditEmbedContainer>
      <blockquote
        className={REDDIT_CLASSNAME}
        style={{ height: `${height}px` }}
        data-embed-height={height}
        {...(theme && { 'data-embed-theme': theme })}
        {...(context !== undefined && { 'data-embed-context': context })}
        {...(depth !== undefined && { 'data-embed-depth': depth })}
        {...(created && { 'data-embed-created': created })}
        {...(showTitle !== null &&
          showTitle !== undefined && {
            'data-embed-showtitle': String(showTitle),
          })}
        {...(hideEdits !== null &&
          hideEdits !== undefined && {
            'data-embed-showedits': String(!hideEdits),
          })}
        {...(hideUsername !== undefined &&
          hideUsername !== null && {
            'data-embed-showusername': String(!hideUsername),
          })}
        {...(locale && { 'data-embed-locale': locale })}
      >
        <a href={commentUrl ?? undefined}>Comment</a>
        <br />
        by <a href={`https://www.reddit.com/user/${author}`}>u/{author}</a> from
        discussion <a href={discussionUrl ?? undefined}></a>
        <br />
        in <a href={`https://www.reddit.com/r/${subreddit}`}>{subreddit}</a>
      </blockquote>
    </RedditEmbedContainer>
  );
};

export default RedditCommentEmbed;
